import React from 'react';
import { QuizPage } from '../components/QuizPage';
export function AdSpend({
  onAnswer
}: {
  onAnswer: (ans: string, dq: boolean) => void;
}) {
  return <QuizPage stepNumber={5} question="What's your approximate monthly ad spend right now?" options={[{
    label: '0-$1,000'
  }, {
    label: '$1,000 - $3,000'
  }, {
    label: '$3,000 - $5,000'
  }, {
    label: '$5,000+'
  }]} onSelect={opt => onAnswer(opt.label, !!opt.isDq)} data-id="element-145" />;
}